module.exports = __webpack_public_path__ + "static/media/ico-check.78248f77.svg";